<template>
  <v-app>
    <component :is="layout">
      <router-view />
    </component>
  </v-app>
</template>

<script>
import Main from '@/layouts/Main'
import Empty from '@/layouts/Empty'
export default {
  name: 'App',
  components: {
    Main,
    Empty
  },
  computed: {
    layout() {
      return this.$route.meta.layout || 'Main'
    }
  }
}
</script>

<style lang="scss">
* {
  font-family: 'Open Sans', sans-serif;
}
thead {
  background: #eff5fe;
  color: rgba(0, 0, 0, 0.54);
  font-family: 'Open Sans', sans-serif;
  th {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 19px;
    padding: 20px 16px !important;
  }
}
tbody {
  font-family: 'Open Sans', sans-serif;
}
.v-btn {
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  letter-spacing: 0.2px;
}
</style>
